module.exports = __webpack_public_path__ + "static/media/rco-regulatory-compliance-icon.01894ee6.svg";